import { configureStore } from '@reduxjs/toolkit'
import salesAreaReducer from './slices/salesAreaSlice';
import configReducer from './slices/configSlice';
import bookingReducer from './slices/bookingSlice';
import leadSourceReducer from './slices/leadSourceSlice';
import pipedriveUserReducer from './slices/pipedriveUserSlice';
import campaignReducer from './slices/campaignSlice';

export default configureStore({
  reducer: {
      config: configReducer,
      salesAreas: salesAreaReducer,
      bookings: bookingReducer,
      leadSource: leadSourceReducer,
      pipedriveUsers: pipedriveUserReducer,
      campaigns: campaignReducer,
  },
})
